import { ReauthenticatableClient } from "@payleo/auth/clients";
import { JURL } from "../utils.js";
export class ArushaClient extends ReauthenticatableClient {
    constructor(auth, baseUrl) {
        super(auth);
        this.endpoint = baseUrl;
    }
    get url() {
        return new JURL(this.endpoint);
    }
}
